import React, { useEffect, useMemo, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useNotifications } from "../../../../hooks/useNotifications";
import Breadcrumb from "../../../../utility/breadcrumb/Breadcrumb";
import { arrowDown } from "../../../../../images";
import formatDate from "../../../../common/DateFormate";
import { toTitleCase } from "../../../../common/TotitleCase";
// import useNotifications from "../../../../hooks/useNotifications";


const MetricBox = ({ label, value, sub, valueStyle }) => (
    <div
        style={{
            background: "#fff",
            //   padding: "0px 10px",
            minWidth: 0,
        }}
    >
        <div className="notification-row-heading">
            {label}
        </div>
        <div className="notification-row-item">{value}</div>
        {sub && <div style={{ fontSize: "13px", color: "#94a3b8", marginTop: 2 }}>{sub}</div>}
    </div>
);


const NotificationDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const {
        notifications,
        setNotifications,
        markAsRead,
        getTypeConfig,
        handleCsvDownload
    } = useNotifications();

    const notificationMap = useMemo(() => {
        return new Map(notifications.map(n => [String(n.ticket_id), n]));
    }, [notifications]);

    const selectedNotification = notificationMap.get(String(id));
    const createdAt = selectedNotification?.created_at;

    const formattedDate = createdAt ? formatDate(createdAt) : null;

    //  Mark as read on open
    useEffect(() => {
        if (selectedNotification && !selectedNotification.isRead) {
            markAsRead(selectedNotification.ticket_id);
        }
    }, [selectedNotification]);
    //  Safety guard
    if (!selectedNotification) {
        return (
            <div className="container py-5">
                <div className="row justify-content-center">
                    <div className="col-md-6 text-center">
                        <div className="not-found-card p-5 rounded-4 shadow-lg">
                            <div className="icon-wrapper mb-3">
                                <i className="bi bi-inbox display-1 text-muted"></i>
                            </div>
                            <h3 className="fw-bold mb-3">Notification Not Found</h3>
                            <p className="text-muted mb-3">
                                The notification you're looking for doesn't exist or has been removed.
                            </p>
                            <button
                                className="btn btn-primary btn-lg rounded-pill px-5 shadow-sm"
                                onClick={() => navigate(-1)}
                                style={{
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    border: 'none',
                                    fontWeight: '600'
                                }}
                            >
                                <i className="bi bi-arrow-left me-2"></i>
                                Go Back
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    /* ---------- helpers ---------- */


    const getPriorityStyle = (priority, type) => {
        const styles = {
            High: { bg: '#fef2f2', color: '#dc2626', icon: 'bi-exclamation-circle-fill' },
            Medium: { bg: '#fff7ed', color: '#ea580c', icon: 'bi-dash-circle-fill' },
            Low: { bg: '#f0fdf4', color: '#16a34a', icon: 'bi-check-circle-fill' },
        };
        return styles[priority] || styles.Medium;
    };

    const cfg = getTypeConfig(selectedNotification.priority);
    const priorityStyle = getPriorityStyle(selectedNotification.priority, selectedNotification.type);

    /* ---------- UI ---------- */

    return (
        <>
            <Breadcrumb title="Notification" componentType="notification" />
            <div className="notification-detail-wrapper" style={{ minHeight: '100vh', paddingTop: '1rem', paddingBottom: '1rem' }}>
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-xl-12">
                            {/* Back Button */}
                            {/* <button className="back-button btn btn-light rounded-pill px-4 mb-3 shadow-sm d-inline-flex align-items-center" onClick={() => navigate(-1)} style={{ background: 'rgba(255, 255, 255, 0.95)', backdropFilter: 'blur(10px)',border: '1px solid rgba(255, 255, 255, 0.5)',fontWeight: '600',transition: 'all 0.3s ease'}}>
                        <i className="bi bi-arrow-left me-2"></i>
                        Back to notifications
                    </button> */}

                            {/* Main Card */}
                            <div className="main-notification-card card border-0 shadow-lg mb-3" style={{ overflow: 'hidden', animation: 'slideUp 0.6s cubic-bezier(0.16, 1, 0.3, 1)' }}>
                                {/* Decorative Header with Gradient */}
                                <div className="card-header position-relative border-0 p-0" style={{ background: (selectedNotification?.type === 'hero_product_alert' || selectedNotification?.type === 'sales_growth') ? '#16a34a' : cfg.gradient, }} >
                                    {/* Decorative Pattern Overlay */}
                                    <div className="position-absolute w-100 h-100" style={{ background: `radial-gradient(circle at 20% 50%, rgba(255,255,255,0.2) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(255,255,255,0.15) 0%, transparent 50%)`, opacity: 0.6 }}></div>
                                    {/* Header Content */}
                                    <div className="position-relative p-2 px-3 text-white h-100 d-flex flex-column justify-content-end">
                                        <div className="d-flex gap-2 mb-0 flex-wrap align-items-center">
                                            <h1 className="kpi-heading text-white" style={{ fontSize: 'clamp(1rem, 1.3vw, 2.5rem)', lineHeight: '1.2', textShadow: '0 2px 10px rgba(0,0,0,0.1)', textTransform: "none" }}>
                                                {toTitleCase(selectedNotification.title)}
                                            </h1>
                                            <span className="badge px-2 py-2 rounded-pill ms-auto text-capitalize" style={{ background: priorityStyle.bg, color: (selectedNotification?.type === 'hero_product_alert' || selectedNotification?.type === 'sales_growth') ? '#16a34a' : priorityStyle.color, fontWeight: '600', fontSize: '0.8rem', border: `2px solid ${priorityStyle.color}20` }}>
                                                <i className={`${priorityStyle.icon} me-1`}></i>
                                                {selectedNotification.priority || "Medium"} Priority
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                {/* Ad Spend No Order */}
                                {(selectedNotification?.payload?.campaigns?.length > 0 && selectedNotification?.type === 'ad_spend_no_order') && (
                                    <div className="card-body p-3">
                                        <>
                                            <div className="d-flex justify-content-between flex-wrap gap-3 mb-0 pb-2 border-bottom">
                                                <div>
                                                    <p className="small mb-0">
                                                        Zero returns on ads spend over the last days
                                                        {/* {selectedNotification.payload.campaigns.length} Campaign{selectedNotification.payload.campaigns.length !== 1 ? 's' : ''} with ad spend but no orders */}
                                                    </p>
                                                </div>
                                                <div className="text-end">
                                                    <button
                                                        className="btn btn-sm shadow-sm border-0 d-flex align-items-center gap-2"
                                                        onClick={() => handleCsvDownload(selectedNotification.id)}
                                                        style={{ background: 'rgba(248, 249, 250,1)', color: 'rgba(40, 40, 40, 1)' }}>
                                                        <i className="bi bi-file-earmark-arrow-down"></i>
                                                        <span className="d-none d-sm-inline">Download Report</span>
                                                        <span className="d-inline d-sm-none">CSV</span>
                                                    </button>
                                                </div>

                                            </div>

                                            <div className="d-flex justify-content-between align-items-center py-2">
                                                <div className="d-flex align-items-center gap-2">
                                                    <i className="bi bi-calendar-check"></i>
                                                    <span className="small">
                                                        {formatDate(selectedNotification?.payload.start_date)}
                                                        <span className="mx-2">-</span>
                                                        {formatDate(selectedNotification?.payload.end_date)}
                                                    </span>
                                                </div>
                                                {formattedDate &&(
                                                <div className="small text-nowrap ms-2 notification-date">
                                                    Created At: {formattedDate}
                                                </div>
                                                )}
                                            </div>
                                            <div>
                                            {selectedNotification?.payload?.campaigns.map((item, idx) => (
                                                <div key={idx} className="mb-3 p-3 rounded-3 bg-light border">
                                                    <div className="d-flex align-items-end gap-2">
                                                        <span className="notification-row-heading">ASIN:</span>
                                                        <span className="notification-row-heading">{item?.asin}</span>
                                                    </div>
                                                    <p className="notification-row-item">{item?.campaign_name?.split("<br>").map((cap_name) => (
                                                        <p className="m-0 d-inline badge bg-secondary-subtle text-secondary me-2">{cap_name}</p>
                                                    ))}</p>

                                                    <div className="d-flex justify-content-between align-items-center small">
                                                        <div className="d-flex align-items-center gap-1">
                                                            <i className="bi bi-cash-coin"></i>
                                                            <span className="notification-row-heading">Spend:</span>
                                                            <span className="notification-row-heading">{item?.spend}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                            </div>
                                        </>
                                    </div>
                                )}
                                {/* High Return - Products List */}
                                {(selectedNotification?.payload?.products?.length > 0 && selectedNotification?.type === 'high_return') && (
                                    <div className="card-body p-3">
                                        {/* Header Section */}
                                        <div className="d-flex align-items-center gap-3 mb-0 pb-2 border-bottom">
                                            <div>
                                                <p className="small mb-0">
                                                    A significant increase in returns detected for your top SKUs
                                                    {/* {selectedNotification.payload.products.length} product{selectedNotification.payload.products.length !== 1 ? 's' : ''} requiring attention */}
                                                </p>
                                            </div>
                                            <div className="ms-auto">
                                                <button
                                                    className="btn btn-sm shadow-sm border-0 d-flex align-items-center gap-2"
                                                    onClick={() => handleCsvDownload(selectedNotification.id)}
                                                    style={{ background: 'rgba(248, 249, 250,1)', color: 'rgba(40, 40, 40, 1)' }}>
                                                    <i className="bi bi-file-earmark-arrow-down"></i>
                                                    <span className="d-none d-sm-inline">Download Report</span>
                                                    <span className="d-inline d-sm-none">CSV</span>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center py-2">
                                            <div className="d-flex align-items-center gap-2">
                                                <i className="bi bi-calendar-check"></i>
                                                <span className="small">
                                                    {formatDate(selectedNotification?.payload.start_date)}
                                                    <span className="mx-2">-</span>
                                                    {formatDate(selectedNotification?.payload.end_date)}
                                                </span>
                                            </div>
                                            {formattedDate &&(
                                            <div className="small text-nowrap ms-2 notification-date">
                                                Created At: {formattedDate}
                                            </div>
                                            )}
                                        </div>

                                        {/* Products Grid */}
                                        <div className="row g-3">
                                            {selectedNotification.payload.products.map((item, idx) => (
                                                <div key={idx} className="col-12">
                                                    <div className="card border-0 shadow-sm hover-shadow transition" style={{ borderLeft: '4px solid #ffc107' }}>
                                                        <div className="card-body p-3">
                                                            {/* Product Header */}
                                                            <div className="d-flex justify-content-between align-items-start mb-3">
                                                                <div>
                                                                    <div className="notification-row-heading">PRODUCT ASIN</div>
                                                                    <h6 className="notification-row-item">{item.asin}</h6>
                                                                </div>
                                                            </div>

                                                            {/* Metrics Grid */}
                                                            <div className="row g-3 mb-3">
                                                                <div className="col-6 col-md-3">
                                                                    <div className="p-3 bg-light rounded-3">
                                                                        <div className="notification-row-heading">Gross Units</div>
                                                                        <div className="notification-row-item">{item.orders}</div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-6 col-md-3">
                                                                    <div className="p-3 bg-danger bg-opacity-10 rounded-3">
                                                                        <div className="notification-row-heading">Returns</div>
                                                                        <div className="notification-row-item">{item.returns}</div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 col-md-6">
                                                                    <div className="p-3 bg-warning bg-opacity-10 rounded-3 h-100">
                                                                        <div className="notification-row-heading">
                                                                            <i className="bi bi-info-circle me-1"></i>
                                                                            Top Return Reason
                                                                        </div>
                                                                        <div className="notification-row-item">{item.top_return_reason}</div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* Visual Return Rate Bar */}
                                                            <div className="mt-3">
                                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                                    <span className="small text-muted">Return Rate</span>
                                                                    <span className="small fw-bold text-danger">{item.return_percent}</span>
                                                                </div>
                                                                <div className="progress" style={{ height: '8px' }}>
                                                                    <div
                                                                        className="progress-bar bg-danger"
                                                                        role="progressbar"
                                                                        style={{ width: item.return_percent }}
                                                                        aria-valuenow={parseFloat(item.return_percent)}
                                                                        aria-valuemin="0"
                                                                        aria-valuemax="100"
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}

                                {/* High Cancellation - Products List */}
                                {(selectedNotification?.payload?.products?.length > 0 && selectedNotification?.type === 'high_cancellation') && (
                                    <div className="card-body p-3">
                                        {/* Header Section */}
                                        <div className="d-flex align-items-center gap-3 pb-2 border-bottom">
                                            <div className="flex-grow-1">
                                                <p className="small mb-0">
                                                    High cancellation volume detected for your top SKUs
                                                    {/* <i className="bi bi-exclamation-circle me-1"></i> */}
                                                    {/* {selectedNotification.payload.products.length} product{selectedNotification.payload.products.length !== 1 ? 's' : ''} with elevated cancellation rates */}
                                                </p>
                                            </div>
                                            <div>
                                                <button
                                                    className="btn btn-sm shadow-sm border-0 d-flex align-items-center gap-2"
                                                    onClick={() => handleCsvDownload(selectedNotification.id)}
                                                    style={{ background: 'rgba(248, 249, 250,1)', color: 'rgba(40, 40, 40, 1)' }}>
                                                    <i className="bi bi-file-earmark-arrow-down"></i>
                                                    <span className="d-none d-sm-inline">Download Report</span>
                                                    <span className="d-inline d-sm-none">CSV</span>
                                                </button>
                                            </div>
                                        </div>

                                        <div className="d-flex justify-content-between align-items-center py-2">
                                            <div className="d-flex align-items-center gap-2">
                                                <i className="bi bi-calendar-check"></i>
                                                <span className="small">
                                                    {formatDate(selectedNotification?.payload.start_date)}
                                                    <span className="mx-2">-</span>
                                                    {formatDate(selectedNotification?.payload.end_date)}
                                                </span>
                                            </div>
                                            {formattedDate &&(
                                            <div className="small text-nowrap ms-2 notification-date">
                                                Created At: {formattedDate}
                                            </div>
                                            )}
                                        </div>

                                        {/* Products Grid */}
                                        <div className="row g-3">
                                            {selectedNotification.payload.products.map((item, idx) => {
                                                const cancelRate = item.cancel_percent || 0;
                                                const rateLevel = cancelRate >= 50 ? 'critical' : cancelRate >= 30 ? 'high' : 'moderate';

                                                return (
                                                    <div key={idx} className="col-12 col-md-4">
                                                        <div className="card border-0 shadow-sm hover-lift" style={{ borderLeft: `4px solid ${rateLevel === 'critical' ? '#dc3545' : rateLevel === 'high' ? '#ffc107' : '#fd7e14'}` }}>
                                                            <div className="card-body p-3">
                                                                {/* Product Header with Status Badge */}
                                                                <div className="d-flex justify-content-between align-items-start mb-1">
                                                                    <div>
                                                                        {/* <div className="notification-row-heading" style={{ letterSpacing: '0.5px', fontSize: '0.7rem' }}>
                                                    Product ASIN
                                                </div> */}
                                                                        <h6 className="mb-0 notification-row-heading align-items-center">ASIN:{item.asin}</h6>
                                                                    </div>
                                                                    {/* <div>
                                                <a href={`https://www.amazon.com/dp/${item.asin}`} target="_blank" rel="noopener noreferrer" className="btn view-product-btn">
                                                    <i className="bi bi-box-arrow-up-right me-1"></i>
                                                    View
                                                </a>
                                            </div> */}
                                                                </div>

                                                                {/* Metrics Grid - Only 2 metrics */}
                                                                <div className="row g-3">
                                                                    <div className="col-12 col-md-6">
                                                                        <div className="p-3 bg-white rounded-4 shadow-sm">
                                                                            <div className="notification-row-heading">Gross Units</div>
                                                                            <div className="notification-row-item">{item.orders}</div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-12 col-md-6 ">
                                                                        <div className="p-3 bg-white bg-opacity-10 rounded-4 shadow-sm">
                                                                            <div className="notification-row-heading">Cancellation</div>
                                                                            <div className="d-flex">
                                                                                <span className="notification-row-item text-dark">{item.cancels}</span>
                                                                                <span className="ms-auto notification-row-item text-danger">
                                                                                    <img alt="Arrow Icon" src={arrowDown}></img>
                                                                                    {cancelRate}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}

                                {/* Out of Stock - Products List */}
                                {(selectedNotification?.payload?.products?.length > 0 && selectedNotification?.type === 'out_of_stock_risk') && (
                                    <div className="card-body p-3">
                                        {/* Header Section */}
                                        <div className="d-flex align-items-center gap-3 mb-0 pb-3 border-bottom">
                                            <div className="flex-grow-1">
                                                <p className="small mb-0">
                                                    Critical inventory levels detected for your key products
                                                </p>
                                            </div>
                                            <div>
                                                <button
                                                    className="btn btn-sm shadow-sm border-0 d-flex align-items-center gap-2"
                                                    onClick={() => handleCsvDownload(selectedNotification.id)}
                                                    style={{ background: 'rgba(248, 249, 250,1)', color: 'rgba(40, 40, 40, 1)' }}>
                                                    <i className="bi bi-file-earmark-arrow-down"></i>
                                                    <span className="d-none d-sm-inline">Download Report</span>
                                                    <span className="d-inline d-sm-none">CSV</span>
                                                </button>
                                            </div>
                                            {selectedNotification.out_of_stock_at && (
                                                <div className="text-end">
                                                    <div className="notification-row-heading">Out of Stock Since</div>
                                                    <div className="fw-semibold text-dark">
                                                        <i className="bi bi-calendar-check me-1"></i>
                                                        {formatDate(selectedNotification.out_of_stock_at)}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center py-2">
                                            <div className="d-flex align-items-center gap-2">
                                                <i className="bi bi-calendar-check"></i>
                                                <span className="small">
                                                    {formatDate(selectedNotification?.payload.start_date)}
                                                    <span className="mx-2">-</span>
                                                    {formatDate(selectedNotification?.payload.end_date)}
                                                </span>
                                            </div>
                                            {formattedDate &&(
                                            <div className="small text-nowrap ms-2 notification-date">
                                                Created At: {formattedDate}
                                            </div>
                                            )}
                                        </div>
                                        {/* Products Grid */}
                                        <div className="row g-3">
                                            {selectedNotification.payload.products.map((item, idx) => (
                                                <div key={idx} className="col-12 col-lg-12">
                                                    <div className="card hover-lift h-100">
                                                        <div className="card-body border-4 p-1 px-2">
                                                            {/* Product Header */}
                                                            <div className="d-flex justify-content-between align-items-start">
                                                                <div className="flex-grow-1 me-2">
                                                                    <h6 className="mb-0 text-dark">{item.name}</h6>
                                                                </div>
                                                            </div>

                                                            {/* Product Details */}
                                                            <div className="row g-2">
                                                                <div className="col-12 col-md-3">
                                                                    <div className="detail-item p-2 rounded-2">
                                                                        <div className="notification-row-heading">
                                                                            ASIN
                                                                        </div>
                                                                        <div className="notification-row-item">
                                                                            {item.asin}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 col-md-3">
                                                                    <div className="detail-item p-2 rounded-2">
                                                                        <div className="notification-row-heading">
                                                                            Current Stock
                                                                        </div>
                                                                        <div className="notification-row-item">
                                                                            {item.current_stock}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 col-md-3">
                                                                    <div className="detail-item p-2 rounded-2">
                                                                        <div className="notification-row-heading">
                                                                            30-Day Sales
                                                                        </div>
                                                                        <div className="notification-row-item">
                                                                            {item.total_sales}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 col-md-3">
                                                                    <div className="detail-item p-2 rounded-2">
                                                                        <div className="notification-row-heading">
                                                                            Days to OOS
                                                                        </div>
                                                                        <div className="notification-row-item">
                                                                            {item.days_to_oos}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}

                                {/* Sales Drop - Products List */}
                                {(selectedNotification?.payload?.products?.length > 0 && selectedNotification?.type === 'sales_drop') && (
                                    <div className="card-body p-3">
                                        {/* Header Section */}
                                        <div className="d-flex align-items-center gap-3 mb-3 pb-3 border-bottom">
                                            <div className="flex-grow-1">
                                                <p className="small mb-0">
                                                    Review your top product{selectedNotification.payload.products.length !== 1 ? 's' : ''} with the highest weekly sales decline and total revenue loss.
                                                </p>
                                            </div>
                                            <div>
                                                <button
                                                    className="btn btn-sm shadow-sm border-0 d-flex align-items-center gap-2"
                                                    onClick={() => handleCsvDownload(selectedNotification.id)}
                                                    style={{ background: 'rgba(248, 249, 250,1)', color: 'rgba(40, 40, 40, 1)' }}>
                                                    <i className="bi bi-file-earmark-arrow-down"></i>
                                                    <span className="d-none d-sm-inline">Download Report</span>
                                                    <span className="d-inline d-sm-none">CSV</span>
                                                </button>
                                            </div>
                                        </div>

                                        {/* Week Comparison Banner */}
                                        {selectedNotification.payload.current_week && selectedNotification.payload.previous_week && (
                                            <div className="row g-2 mb-3">
                                                <div className="col-12 col-md-3 ">
                                                    <div className="p-2 rounded-3 border">
                                                        <div className="notification-row-heading">
                                                            <i className="bi bi-calendar-check me-1"></i>
                                                            Previous Week
                                                        </div>
                                                        <div className="fw-semibold text-dark small">
                                                            {formatDate(selectedNotification.payload.previous_week.split('..')[0])} {formatDate(selectedNotification.payload.previous_week.split('..')[1])}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-3">
                                                    <div className="p-2 rounded-3 border">
                                                        <div className="notification-row-heading">
                                                            <i className="bi bi-calendar-check me-1"></i>
                                                            Current Week
                                                        </div>
                                                        <div className="fw-semibold text-dark small">
                                                            {formatDate(selectedNotification.payload.current_week.split('..')[0])} {formatDate(selectedNotification.payload.current_week.split('..')[1])}
                                                        </div>
                                                    </div>
                                                </div>
                                                {formattedDate &&(
                                                <div className="col-12 col-md-6 test-end">
                                                <div className="small text-nowrap notification-date justify-content-end d-flex">
                                                    Created At: {formattedDate}
                                                </div>
                                                </div>
                                                )}
                                            </div>
                                        )}

                                        {/* Products Grid */}
                                        <div className="row g-3">
                                            {selectedNotification.payload.products.map((item, idx) => {
                                                const salesDropPercent = Math.abs(item.sales_change_percent);
                                                const severityLevel = salesDropPercent >= 75 ? 'critical' : salesDropPercent >= 50 ? 'high' : 'moderate';

                                                return (
                                                    <div key={idx} className="col-12">
                                                        <div className="card border-0 shadow-sm hover-lift" style={{
                                                            borderLeft: `4px solid ${severityLevel === 'critical' ? '#dc3545' : severityLevel === 'high' ? '#fd7e14' : '#ffc107'}`
                                                        }}>
                                                            <div className="card-body p-3">
                                                                {/* Product Header */}
                                                                <div className="d-flex justify-content-between align-items-start mb-3 flex-wrap gap-2">
                                                                    <div className="flex-grow-1">
                                                                        <div className="notification-row-heading">
                                                                            Product
                                                                        </div>
                                                                        <h6 className="notification-row-heading">{item.name}</h6>
                                                                        <span className="notification-row-item">ASIN: {item.asin}</span>
                                                                    </div>
                                                                </div>
                                                                {/* Week Comparison Metrics */}
                                                                <div className="row g-3 mb-3">
                                                                    {/* Sales Comparison */}
                                                                    <div className="col-12">
                                                                        <div className="p-3 bg-light rounded-3">
                                                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                                                <span className="small fw-medium text-dark">
                                                                                    <i className="bi bi-cash-stack me-1"></i>
                                                                                    Net Sales Comparison
                                                                                </span>
                                                                                <span className={`badge ${parseFloat(item.sales_change_percent) < 0 ? 'bg-danger' : 'bg-success'}`}>
                                                                                    {item.sales_change_percent > 0 ? '+' : ''}{item.sales_change_percent}
                                                                                </span>
                                                                            </div>
                                                                            <div className="row g-2">
                                                                                <div className="col-4">
                                                                                    <div className="p-2 bg-white rounded-2">
                                                                                        <div className="notification-row-heading">Previous Week</div>
                                                                                        <div className="notification-row-item">
                                                                                            {item.previous_week_sales}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-4">
                                                                                    <div className="p-2 bg-white rounded-2">
                                                                                        <div className="notification-row-heading">Current Week</div>
                                                                                        <div className="notification-row-item">
                                                                                            {item.current_week_sales}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-4">
                                                                                    <div className="p-2 bg-white rounded-2">
                                                                                        <div className="notification-row-heading">Sales Lost</div>
                                                                                        <div className="notification-row-item">
                                                                                            {item.net_sales_lost}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    {/* Units Comparison */}
                                                                    <div className="col-12">
                                                                        <div className="p-3 bg-light rounded-3">
                                                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                                                <span className="small fw-medium text-dark">
                                                                                    <i className="bi bi-box-seam me-1"></i>
                                                                                    Units Sold Comparison
                                                                                </span>
                                                                                <span className={`badge ${parseFloat(item.units_change_percent) < 0 ? 'bg-danger' : 'bg-success'}`}>
                                                                                    {item.units_change_percent > 0 ? '+' : ''}{item.units_change_percent}
                                                                                </span>
                                                                            </div>
                                                                            <div className="row g-2">
                                                                                <div className="col-6">
                                                                                    <div className="p-2 bg-white rounded-2">
                                                                                        <div className="notification-row-heading">Previous Week</div>
                                                                                        <div className="notification-row-item">
                                                                                            {item.previous_week_units} units
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-6">
                                                                                    <div className="p-2 bg-white rounded-2">
                                                                                        <div className="notification-row-heading">Current Week</div>
                                                                                        <div className="notification-row-item">
                                                                                            {item.current_week_units} units
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}

                                {/* Sales Growth - Products List */}
                                {(selectedNotification?.payload?.products?.length > 0 && selectedNotification?.type === 'sales_growth') && (
                                    <div className="card-body p-3">
                                        {/* Header Section */}
                                        <div className="d-flex align-items-center gap-3 mb-4 pb-3 border-bottom">
                                            <div className="flex-grow-1">
                                                <p className="small mb-0">
                                                    Your sales are up by this week check your top-performing ASINs to optimize your ads and inventory.
                                                    {formattedDate &&(
                                                    <div className="small text-nowrap notification-date">
                                                        Created At: {formattedDate}
                                                    </div>
                                                    )}
                                                    {/* {selectedNotification.payload.products.length} product{selectedNotification.payload.products.length !== 1 ? 's' : ''} with declining performance */}
                                                </p>
                                            </div>
                                            <div>
                                                <button
                                                    className="btn btn-sm shadow-sm border-0 d-flex align-items-center gap-2"
                                                    onClick={() => handleCsvDownload(selectedNotification.id)}
                                                    style={{ background: 'rgba(248, 249, 250,1)', color: 'rgba(40, 40, 40, 1)' }}>
                                                    <i className="bi bi-file-earmark-arrow-down"></i>
                                                    <span className="d-none d-sm-inline">Download Report</span>
                                                    <span className="d-inline d-sm-none">CSV</span>
                                                </button>
                                            </div>
                                        </div>

                                        {/* Week Comparison Banner */}
                                        {selectedNotification.payload.current_week && selectedNotification.payload.previous_week && (
                                            <div className="row g-2 mb-4">
                                                <div className="col-12 col-md-3">
                                                    <div className="p-2 rounded-3 border">
                                                        <div className="notification-row-heading">
                                                            <i className="bi bi-calendar-check me-1"></i>
                                                            Previous Week
                                                        </div>
                                                        <div className="fw-semibold text-dark small">
                                                            {formatDate(selectedNotification.payload.previous_week.split('..')[0])}  {formatDate(selectedNotification.payload.previous_week.split('..')[1])}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-3">
                                                    <div className="p-2 rounded-3 border">
                                                        <div className="notification-row-heading">
                                                            <i className="bi bi-calendar-check me-1"></i>
                                                            Current Week
                                                        </div>
                                                        <div className="fw-semibold text-dark small">
                                                            {formatDate(selectedNotification.payload.current_week.split('..')[0])}  {formatDate(selectedNotification.payload.current_week.split('..')[1])}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Products Grid */}
                                        <div className="row g-3">
                                            {selectedNotification.payload.products.map((item, idx) => {
                                                const salesDropPercent = Math.abs(item.growth_percent);
                                                const severityLevel = salesDropPercent >= 75 ? 'critical' : salesDropPercent >= 50 ? 'high' : 'moderate';

                                                return (
                                                    <div key={idx} className="col-12">
                                                        <div className="card border-0 shadow-sm hover-lift" style={{
                                                            borderLeft: `4px solid ${severityLevel === 'critical' ? '#dc3545' : severityLevel === 'high' ? '#fd7e14' : '#ffc107'}`
                                                        }}>
                                                            <div className="card-body p-3">
                                                                {/* Product Header */}
                                                                <div className="d-flex justify-content-between align-items-start mb-3 flex-wrap gap-2">
                                                                    <div className="flex-grow-1">
                                                                        <div className="notification-row-heading" style={{ letterSpacing: '0.5px', fontSize: '0.7rem' }}>
                                                                            Product Name
                                                                        </div>
                                                                        <h6 className="notification-row-heading">{item.product_name}</h6>
                                                                        <span className="notification-row-heading">ASIN: {item.asin}</span>
                                                                    </div>
                                                                </div>

                                                                {/* Week Comparison Metrics */}
                                                                <div className="row g-3 mb-3">
                                                                    {/* Sales Comparison */}
                                                                    <div className="col-12">
                                                                        <div className="p-3 bg-light rounded-3">
                                                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                                                <span className="small fw-medium text-dark">
                                                                                    <i className="bi bi-cash-stack me-1"></i>
                                                                                    Net Sales Comparison
                                                                                </span>
                                                                                <span className={`badge ${item.growth_percent < 0 ? 'bg-danger' : 'bg-success'}`}>
                                                                                    {item.growth_percent}
                                                                                </span>
                                                                            </div>
                                                                            <div className="row g-2">
                                                                                <div className="col-4">
                                                                                    <div className="p-2 bg-white rounded-2">
                                                                                        <div className="notification-row-heading">Previous Week</div>
                                                                                        <div className="notification-row-item">
                                                                                            {item.previous_week_sales}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-4">
                                                                                    <div className="p-2 bg-white rounded-2">
                                                                                        <div className="notification-row-heading">Current Week</div>
                                                                                        <div className="notification-row-item">
                                                                                            {item.current_week_sales}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-4">
                                                                                    <div className="p-2 bg-white rounded-2">
                                                                                        <div className="notification-row-heading">Sales Increase</div>
                                                                                        <div className="notification-row-item">
                                                                                            {item.sales_increase}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}

                                {/* Ads Dependency Alert */}
                                {(selectedNotification?.payload?.products?.length > 0 && selectedNotification?.type === 'ad_dependency') && (
                                    <div className="card-body p-3">
                                        {/* Header Section */}
                                        <div className="d-flex align-items-center gap-3 pb-3 border-bottom">
                                            <div className="flex-grow-1">
                                                <p className="mb-1">High ads spend vs low organic reach is eating your margins</p>
                                            </div>
                                            <div>
                                                <button
                                                    className="btn btn-sm shadow-sm border-0 d-flex align-items-center gap-2"
                                                    onClick={() => handleCsvDownload(selectedNotification.id)}
                                                    style={{ background: 'rgba(248, 249, 250,1)', color: 'rgba(40, 40, 40, 1)' }}>
                                                    <i className="bi bi-file-earmark-arrow-down"></i>
                                                    <span className="d-none d-sm-inline">Download Report</span>
                                                    <span className="d-inline d-sm-none">CSV</span>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center py-2">
                                            <div className="d-flex align-items-center gap-2">
                                                <i className="bi bi-calendar-check"></i>
                                                <span className="small">
                                                    {formatDate(selectedNotification?.payload.start_date)}
                                                    <span className="mx-2">-</span>
                                                    {formatDate(selectedNotification?.payload.end_date)}
                                                </span>
                                            </div>
                                            {formattedDate &&(
                                            <div className="small text-nowrap ms-2 notification-date">
                                                Created At: {formattedDate}
                                            </div>
                                            )}
                                        </div>

                                        {/* Products Grid */}
                                        <div className="row g-3">
                                            {selectedNotification.payload.products.map((item, idx) => (
                                                <div key={idx} className="col-12 col-lg-12">
                                                    <div className="card shadow-sm hover-lift h-100">
                                                        <div className="card-body border-4 p-1 px-2">
                                                            {/* Product Header */}
                                                            {/* <div className="d-flex justify-content-between align-items-start">
                                                                    <div className="flex-grow-1 me-2">
                                                                        <h6 className="mb-0 text-dark">{item.name}</h6>
                                                                    </div>
                                                                </div> */}
                                                            <div className="col-12">
                                                                <div className="detail-item p-2 rounded-2">
                                                                    <div className="fw-semibold text-dark" style={{ fontSize: "0.9rem" }}>
                                                                        <div>
                                                                        <span className="text-muted me-1" style={{ fontSize: "0.7rem", textTransform: "uppercase", letterSpacing: "0.5px", }}>
                                                                            Campaign Name:
                                                                        </span>
                                                                        </div>
                                                                        <p className="notification-row-item mb-0">{item?.campaign_name?.split("<br>").map((cap_name) => (
                                                                            <p className="m-0 d-inline badge bg-secondary-subtle text-secondary me-2">{cap_name}</p>
                                                                        ))}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {/* Product Details */}
                                                            <div className="row g-2">
                                                                <div className="col-2">
                                                                    <div className="detail-item p-2 rounded-2">
                                                                        <div className="notification-row-heading">
                                                                            ASIN
                                                                        </div>
                                                                        <div className="notification-row-item">
                                                                            {item.asin}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-2">
                                                                    <div className="detail-item p-2 rounded-2">
                                                                        <div className="notification-row-heading">
                                                                            Ads Spend
                                                                        </div>
                                                                        <div className="notification-row-item">
                                                                            {item.ad_spend}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-2">
                                                                    <div className="detail-item p-2 rounded-2">
                                                                        <div className="notification-row-heading">
                                                                            Ads Sales
                                                                        </div>
                                                                        <div className="notification-row-item">
                                                                            {item.ads_sales}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-2">
                                                                    <div className="detail-item p-2 rounded-2">
                                                                        <div className="notification-row-heading">
                                                                            Actual Orders
                                                                        </div>
                                                                        <div className="notification-row-item">
                                                                            {item.actual_orders}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-2">
                                                                    <div className="detail-item p-2 rounded-2">
                                                                        <div className="notification-row-heading">
                                                                            Net Sales
                                                                        </div>
                                                                        <div className="notification-row-item">
                                                                            {item.net_sales}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-2">
                                                                    <div className="detail-item p-2 rounded-2">
                                                                        <div className="notification-row-heading">
                                                                            Organic Percentage
                                                                        </div>
                                                                        <div className="notification-row-item">
                                                                            {item.organic_percent}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}

                                {/* Loss Making Sku Alert */}
                                {(selectedNotification?.payload?.products?.length > 0 &&
                                    selectedNotification?.type === "loss_making_sku_alert") && (
                                        <div className="p-3">

                                            {/* Header */}
                                            <div className="d-flex align-items-center gap-3 mb-0 pb-3 border-bottom">
                                                <div className="flex-grow-1">
                                                    <p className="mb-1">Negative margins found for ASIN</p>
                                                </div>
                                                <div>
                                                    <button
                                                        className="btn btn-sm shadow-sm border-0 d-flex align-items-center gap-2"
                                                        onClick={() => handleCsvDownload(selectedNotification.id)}
                                                        style={{ background: 'rgba(248, 249, 250,1)', color: 'rgba(40, 40, 40, 1)' }}>
                                                        <i className="bi bi-file-earmark-arrow-down"></i>
                                                        <span className="d-none d-sm-inline">Download Report</span>
                                                        <span className="d-inline d-sm-none">CSV</span>
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center py-2">
                                                <div className="d-flex align-items-center gap-2">
                                                    <i className="bi bi-calendar-check"></i>
                                                    <span className="small">
                                                        {formatDate(selectedNotification?.payload.start_date)}
                                                        <span className="mx-2">-</span>
                                                        {formatDate(selectedNotification?.payload.end_date)}
                                                    </span>
                                                </div>
                                                {formattedDate &&(
                                                <div className="small text-nowrap ms-2 notification-date">
                                                    Created At: {formattedDate}
                                                </div>
                                                )}
                                            </div>
                                            {/* Product Cards */}
                                            <div className="d-flex flex-column gap-3">
                                                {selectedNotification.payload.products.map((item, idx) => {

                                                    return (
                                                        <div
                                                            key={idx}
                                                            className="card border-0 shadow-sm"
                                                            style={{
                                                                borderRadius: "14px",
                                                                background: "#ffffff",
                                                            }}
                                                        >
                                                            <div className="card-body p-3">

                                                                {/* Top Section */}
                                                                <div className="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-2">

                                                                    {/* Left: SKU Info */}
                                                                    <div style={{ flex: 1, minWidth: 0 }}>
                                                                        <h6
                                                                            title={item.sku}
                                                                            className="notification-row-heading mb-0"
                                                                        >
                                                                            <span
                                                                                style={{
                                                                                    fontSize: "0.72rem",
                                                                                    color: "#475569",
                                                                                    background: "#f1f5f9",
                                                                                    padding: "3px 8px",
                                                                                    borderRadius: "6px",
                                                                                    fontFamily: "monospace",
                                                                                    marginRight: "6px"
                                                                                }}
                                                                            >
                                                                            SKU: {item.sku}
                                                                            </span>
                                                                            <span
                                                                                style={{
                                                                                    fontSize: "0.72rem",
                                                                                    color: "#475569",
                                                                                    background: "#f1f5f9",
                                                                                    padding: "3px 8px",
                                                                                    borderRadius: "6px",
                                                                                    fontFamily: "monospace",
                                                                                }}
                                                                            >
                                                                                ASIN: {item.asin}
                                                                            </span>
                                                                        </h6>
                                                                    </div>

                                                                </div>

                                                                {/* Metrics Section */}
                                                                <div
                                                                    className="mt-3"
                                                                    style={{
                                                                        display: "grid",
                                                                        gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
                                                                        gap: "10px",
                                                                    }}
                                                                >
                                                                    <MetricBox
                                                                        label="Fee %"
                                                                        value={item.fee_percentage}
                                                                    />
                                                                    <MetricBox
                                                                        label="Net Sales"
                                                                        value={item.sales}
                                                                    />
                                                                    <MetricBox
                                                                        label="Ads Spend"
                                                                        value={item.ad_spend}
                                                                    />
                                                                    <MetricBox
                                                                        label="Shipping"
                                                                        value={item?.shipping === 0 ? "-" : item?.shipping}
                                                                    />
                                                                    <MetricBox
                                                                        label="Other Fee"
                                                                        value={item.other_fees}
                                                                    />
                                                                    <MetricBox
                                                                        label="Net Margin"
                                                                        value={item.net_margin}
                                                                    />
                                                                </div>

                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    )}


                                {/* Best Selling Time Alert */}
                                {(selectedNotification?.payload &&
                                    selectedNotification?.type === "best_selling_time_alert") && (
                                        <div className="card-body p-3">

                                            {/* Header Section */}
                                            <div className="d-flex align-items-center gap-3 mb-0 pb-3 border-bottom">
                                                <div className="flex-grow-1">
                                                    <p className="mb-1">Take advantage of your best-selling hours</p>
                                                </div>
                                                <div>
                                                    <button
                                                        className="btn btn-sm shadow-sm border-0 d-flex align-items-center gap-2"
                                                        onClick={() => handleCsvDownload(selectedNotification.id)}
                                                        style={{ background: 'rgba(248, 249, 250,1)', color: 'rgba(40, 40, 40, 1)' }}>
                                                        <i className="bi bi-file-earmark-arrow-down"></i>
                                                        <span className="d-none d-sm-inline">Download Report</span>
                                                        <span className="d-inline d-sm-none">CSV</span>
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center py-2">
                                                <div className="d-flex align-items-center gap-2">
                                                    <i className="bi bi-calendar-check"></i>
                                                    <span className="small">
                                                        {formatDate(selectedNotification?.payload.start_date)}
                                                        <span className="mx-2">-</span>
                                                        {formatDate(selectedNotification?.payload.end_date)}
                                                    </span>
                                                </div>
                                                {formattedDate &&(
                                                <div className="small text-nowrap ms-2 notification-date">
                                                    Created At: {formattedDate}
                                                </div>
                                                )}
                                            </div>

                                            {/* Single Card (no map because payload is object) */}
                                            <div className="row g-3">
                                                <div className="col-12">
                                                    <div className="card shadow-sm hover-lift h-100">
                                                        <div className="card-body border-4 p-1 px-2">

                                                            <div className="row g-2 border-bottom">
                                                                <div className="col-2">
                                                                    <div className="detail-item p-2 rounded-2">
                                                                        <div
                                                                            className="notification-row-heading"
                                                                        >
                                                                            CONTRIBUTION
                                                                        </div>
                                                                        <div
                                                                            className="notification-row-item"
                                                                        >
                                                                            {selectedNotification.payload.contribution}
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-2">
                                                                    <div className="detail-item p-2 rounded-2">
                                                                        <div
                                                                            className="notification-row-heading"

                                                                        >
                                                                            SLOT
                                                                        </div>
                                                                        <div
                                                                            className="notification-row-item"
                                                                        >
                                                                            {selectedNotification.payload.slot}
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-2">
                                                                    <div className="detail-item p-2 rounded-2">
                                                                        <div
                                                                            className="notification-row-heading"

                                                                        >
                                                                            Current Week Sales
                                                                        </div>
                                                                        <div
                                                                            className="notification-row-item"
                                                                        >
                                                                            {selectedNotification.payload.current_week_sales}
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-2">
                                                                    <div className="detail-item p-2 rounded-2">
                                                                        <div
                                                                            className="notification-row-heading"

                                                                        >
                                                                            Previous Week Sales
                                                                        </div>
                                                                        <div
                                                                            className="notification-row-item"
                                                                        >
                                                                            {selectedNotification.payload.previous_week_sales}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-2">
                                                                    <div className="detail-item p-2 rounded-2">
                                                                        <div
                                                                            className="notification-row-heading"

                                                                        >
                                                                            Peak Week
                                                                        </div>
                                                                        <div
                                                                            className="notification-row-item"
                                                                        >
                                                                            {selectedNotification.payload.peak_week}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row g-2 ">
                                                                <div className="col-2">
                                                                    <div className="detail-item p-2 rounded-2">
                                                                        <div
                                                                            className="mb-1 notification-row-heading"
                                                                        >
                                                                            ASIN
                                                                        </div>
                                                                        <div
                                                                            className="notification-row-item"                                        >
                                                                            {selectedNotification?.payload?.rows[0]?.asin}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-2">
                                                                    <div className="detail-item p-2 rounded-2">
                                                                        <div
                                                                            className="mb-1 notification-row-heading"
                                                                        >
                                                                            SALES
                                                                        </div>
                                                                        <div
                                                                            className="notification-row-item"
                                                                        >
                                                                            {selectedNotification?.payload?.rows[0]?.sales}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-2">
                                                                    <div className="detail-item p-2 rounded-2">
                                                                        <div
                                                                            className="notification-row-heading"
                                                                        >
                                                                            UNITS
                                                                        </div>
                                                                        <div
                                                                            className="notification-row-item"
                                                                        >
                                                                            {selectedNotification?.payload?.rows[0]?.units}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-2">
                                                                    <div className="detail-item p-2 rounded-2">
                                                                        <div
                                                                            className="notification-row-heading"
                                                                        >
                                                                            orders
                                                                        </div>
                                                                        <div
                                                                            className="notification-row-item"
                                                                        >
                                                                            {selectedNotification?.payload?.rows[0]?.orders}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-2">
                                                                    <div className="detail-item p-2 rounded-2">
                                                                        <div
                                                                            className="notification-row-heading"
                                                                        >
                                                                            TIME SLOT
                                                                        </div>
                                                                        <div
                                                                            className="notification-row-item"
                                                                        >
                                                                            {selectedNotification?.payload?.rows[0]?.time_slot}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                {/* Payment Pending Alert */}
                                {(selectedNotification?.payload?.orders?.length > 0 &&
                                    selectedNotification?.type === 'pending_payment') && (() => {

                                        const orders = selectedNotification.payload.orders;

                                        return (
                                            <div >

                                                {/* Header Section */}
                                                <div className="d-flex align-items-center gap-3 mx-3 pb-3 mt-2 mb-3 border-bottom">
                                                    <div className="flex-grow-1">
                                                        <p className="mb-1">Delivered orders is currently unsettled</p>
                                                        {formattedDate &&(
                                                        <div className="small text-nowrap notification-date">
                                                            Created At: {formattedDate}
                                                        </div>
                                                        )}
                                                    </div>
                                                    <div>
                                                        <button
                                                            className="btn btn-sm shadow-sm border-0 d-flex align-items-center gap-2"
                                                            onClick={() => handleCsvDownload(selectedNotification.id)}
                                                            style={{ background: 'rgba(248, 249, 250,1)', color: 'rgba(40, 40, 40, 1)' }}>
                                                            <i className="bi bi-file-earmark-arrow-down"></i>
                                                            <span className="d-none d-sm-inline">Download Report</span>
                                                            <span className="d-inline d-sm-none">CSV</span>
                                                        </button>
                                                    </div>
                                                </div>


                                                {/* ── Column Headers ───────────────────────────────────── */}
                                                <div style={{
                                                    display: 'grid',
                                                    gridTemplateColumns: "repeat(6, 1fr)",
                                                    gap: '12px',
                                                    padding: '0px 35px 5px',
                                                    alignItems: 'center',
                                                }}>
                                                    {['Order ID', 'ASIN', 'SKU', 'Status', 'Amount', 'Order Date'].map((col, i) => (
                                                        <span key={i} className="notification-row-heading">{col}</span>
                                                    ))}
                                                </div>

                                                {/* ── Orders List ──────────────────────────────────────── */}
                                                <div style={{ padding: '16px 28px 24px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                                    {orders.map((item, idx) => {

                                                        return (
                                                            <div
                                                                key={idx}
                                                                style={{
                                                                    borderRadius: '14px',
                                                                    overflow: 'hidden',
                                                                }}
                                                            >
                                                                {/* Left accent bar */}
                                                                <div style={{ display: 'flex', alignItems: 'stretch' }}>
                                                                    <div style={{ width: '5px', flexShrink: 0 }} />

                                                                    <div style={{
                                                                        flex: 1,
                                                                        // padding: '16px 20px',
                                                                        display: 'grid',
                                                                        gridTemplateColumns: "repeat(6, 1fr)",
                                                                        gap: '12px',
                                                                        alignItems: 'center',
                                                                    }}>

                                                                        {/* Order ID */}
                                                                        <div style={{ minWidth: 0 }}>
                                                                            <div className="notification-row-item">
                                                                                {item.order_id || '—'}
                                                                            </div>
                                                                        </div>

                                                                        {/* ASIN */}
                                                                        <div style={{ minWidth: 0 }}>
                                                                            <div className="notification-row-item">
                                                                                {item.asin || '—'}
                                                                            </div>
                                                                        </div>

                                                                        {/* SKU */}
                                                                        <div style={{ minWidth: 0 }}>
                                                                            <div className="notification-row-item">
                                                                                {item.sku || '—'}
                                                                            </div>
                                                                        </div>


                                                                        {/* Status Badge */}
                                                                        <div className="notification-row-item">
                                                                            {item.status || 'Unknown'}
                                                                        </div>

                                                                        {/* Amount */}
                                                                        <div className="notification-row-item">
                                                                            {item.order_amount || '—'}
                                                                        </div>

                                                                        {/* Date */}
                                                                        <div className="notification-row-item">
                                                                            {formatDate(item.order_date)}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>

                                            </div>
                                        );
                                    })()}

                                {/* Hero Product Alert */}
                                {(selectedNotification?.payload?.products?.length > 0 && selectedNotification?.type === 'hero_product_alert') && (() => {

                                    const products = selectedNotification.payload.products;

                                    return (
                                        <div>
                                            {/* Header */}
                                            <div className="d-flex align-items-center gap-3 mx-3 pb-3 mt-2 mb-3 border-bottom">
                                                <div className="flex-grow-1">
                                                    <p className="mb-1">You have products with 3 weeks of rising sales</p>
                                                    {formattedDate &&(
                                                    <div className="small text-nowrap ms-2 notification-date">
                                                    Created At: {formattedDate}
                                                    </div>
                                                    )}
                                                </div>

                                                {/* CSV Download (base64 file) */}
                                                <div>
                                                    <button
                                                        className="btn btn-sm shadow-sm border-0 d-flex align-items-center gap-2"
                                                        onClick={() => handleCsvDownload(selectedNotification.id)}
                                                        style={{ background: 'rgba(248, 249, 250,1)', color: 'rgba(40, 40, 40, 1)' }}>
                                                        <i className="bi bi-file-earmark-arrow-down"></i>
                                                        <span className="d-none d-sm-inline">Download Report</span>
                                                        <span className="d-inline d-sm-none">CSV</span>
                                                    </button>
                                                </div>
                                            </div>


                                            {selectedNotification?.payload?.week_ranges && (
                                                <div className="mt-3 pb-3 px-3">
                                                    <h6 className="notification-row-heading mb-2">Week Ranges</h6>

                                                    <div className="row g-2">
                                                        {Object.entries(selectedNotification.payload.week_ranges).map(
                                                            ([key, value]) => (
                                                                <div className="col-4" key={key}>
                                                                    <div className="border rounded text-center p-2 bg-light">
                                                                        <div className="notification-row-heading">{key.toUpperCase()}</div>
                                                                        <div className="small notification-row-item text-muted">{value}</div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        )}
                                                    </div>
                                                </div>
                                            )}

                                            {/* Column Headers */}
                                            <div
                                                className="px-3"
                                                style={{
                                                    display: 'grid',
                                                    gridTemplateColumns: "repeat(10, 1fr)",
                                                    gap: '12px',
                                                    // padding: '0px 35px 5px',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                {[
                                                    'ASIN',
                                                    'SKU',
                                                    'W1 Units',
                                                    'W1 Sales',
                                                    'W2 Units',
                                                    'W2 Sales',
                                                    'W3 Units',
                                                    'W3 Sales',
                                                    'CW vs LW %',
                                                    'LW vs LLW %'
                                                ].map((col, i) => (
                                                    <span
                                                        key={i}
                                                        className="notification-row-heading"
                                                    >
                                                        {col}
                                                    </span>
                                                ))}
                                            </div>

                                            {/* Product Rows */}
                                            <div
                                                className="px-3"
                                                style={{
                                                    // padding: '16px 28px 24px',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: '10px',
                                                }}
                                            >
                                                {products.map((item, idx) => {
                                                    return (
                                                        <div
                                                            key={idx}
                                                            style={{
                                                                overflow: 'hidden',
                                                            }}
                                                        >
                                                            <div
                                                                className="py-2"
                                                                style={{
                                                                    display: 'grid',
                                                                    gridTemplateColumns: "repeat(10, 1fr)",
                                                                    gap: '12px',
                                                                    alignItems: 'center',
                                                                    // padding: '5px 5px',
                                                                }}
                                                            >
                                                                {/* ASIN */}
                                                                <div style={{ minWidth: 0 }}>
                                                                    <div
                                                                        className="notification-row-item"
                                                                    >
                                                                        {item.asin || '—'}
                                                                    </div>
                                                                </div>

                                                                {/* SKU */}
                                                                <div style={{ minWidth: 0 }}>
                                                                    <div
                                                                        className="notification-row-item"
                                                                    >
                                                                        {item.sku || '—'}
                                                                    </div>
                                                                </div>

                                                                {/* W1 Units */}
                                                                <div className="notification-row-item">
                                                                    {item.w1_units ?? '—'}
                                                                </div>

                                                                {/* W1 Sales */}
                                                                <div
                                                                    className="notification-row-item"
                                                                >
                                                                    {item.w1_sales ?? 0}
                                                                </div>

                                                                {/* W2 Units */}
                                                                <div className="notification-row-item">
                                                                    {item.w2_units ?? '—'}
                                                                </div>

                                                                {/* W2 Sales */}
                                                                <div
                                                                    className="notification-row-item"
                                                                >
                                                                    {item.w2_sales ?? 0}
                                                                </div>

                                                                {/* W3 Units */}
                                                                <div className="notification-row-item">
                                                                    {item.w3_units ?? '—'}
                                                                </div>

                                                                {/* W3 Sales */}
                                                                <div
                                                                    className="notification-row-item"
                                                                >
                                                                    {item.w3_sales ?? 0}
                                                                </div>

                                                                {/* CW vs LW Growth */}
                                                                <div className="notification-row-item">
                                                                    <span
                                                                    >
                                                                        {item.cw_lw_growth ?? 0}
                                                                    </span>
                                                                </div>

                                                                {/* LW vs LLW Growth */}
                                                                <div className="notification-row-item">
                                                                    <span
                                                                    >
                                                                        {item.lw_llw_growth ?? 0}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    );
                                })()}

                                {/* SLow Day Alert */}
                                {(selectedNotification?.payload && selectedNotification?.type === 'slow_day_alert') && (() => {

                                    return (
                                        <div>
                                            {/* Header */}
                                            <div className="d-flex align-items-center gap-3 mx-3 pb-3 mt-2 mb-0 border-bottom">
                                                <div className="flex-grow-1">
                                                    <p className="mb-1">Weekly Product Performance Report</p>
                                                </div>
                                                {/* CSV Download (base64 file) */}
                                                <div>
                                                    <button
                                                        className="btn btn-sm shadow-sm border-0 d-flex align-items-center gap-2"
                                                        onClick={() => handleCsvDownload(selectedNotification.id)}
                                                        style={{ background: 'rgba(248, 249, 250,1)', color: 'rgba(40, 40, 40, 1)' }}>
                                                        <i className="bi bi-file-earmark-arrow-down"></i>
                                                        <span className="d-none d-sm-inline">Download Report</span>
                                                        <span className="d-inline d-sm-none">CSV</span>
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center py-2 px-3">
                                                <div className="d-flex align-items-center gap-2">
                                                    <i className="bi bi-calendar-check"></i>
                                                    <span className="small">
                                                        {formatDate(selectedNotification?.payload.start_date)}
                                                        <span className="mx-2">-</span>
                                                        {formatDate(selectedNotification?.payload.end_date)}
                                                    </span>
                                                </div>
                                                {formattedDate && (
                                                <div className="small text-nowrap ms-2 notification-date">
                                                    Created At: {formattedDate}
                                                </div>
                                                )}
                                            </div>


                                            {/* Column Headers */}
                                            <div
                                                style={{
                                                    display: 'grid',
                                                    gridTemplateColumns: "repeat(3, 1fr)",
                                                    gap: '12px',
                                                    padding: '0px 35px 5px',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                {[
                                                    'AVG Sales Last 7 Days',
                                                    'Lowest Sales',
                                                    'Slow Day',
                                                ].map((col, i) => (
                                                    <span
                                                        key={i}
                                                        style={{
                                                            fontSize: ' 0.8rem',
                                                            fontWeight: 600,
                                                            color: 'rgba(33, 37, 41, 1)',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.7px',
                                                        }}
                                                    >
                                                        {col}
                                                    </span>
                                                ))}
                                            </div>

                                            {/* Product Rows */}
                                            <div
                                                style={{
                                                    display: 'grid',
                                                    gridTemplateColumns: "repeat(3, 1fr)",
                                                    gap: '12px',
                                                    padding: '0px 35px 5px',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                {/* avg_sales_last_7_days */}
                                                <div
                                                    className="notification-row-item"
                                                >
                                                    {selectedNotification?.payload.avg_sales_last_7_days || '—'}
                                                </div>

                                                {/* lowest_sales */}
                                                <div
                                                    style={{
                                                        fontSize: '13px',
                                                        fontWeight: 600,
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        color: 'rgb(107, 114, 128)',
                                                    }}
                                                >
                                                    {selectedNotification?.payload.lowest_sales || '—'}
                                                </div>

                                                {/* slow_day */}
                                                <div
                                                    style={{
                                                        fontSize: '13px',
                                                        fontWeight: 600,
                                                        color: 'rgb(107, 114, 128)',
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                    }}
                                                >
                                                    {selectedNotification?.payload.slow_day || '—'}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })()}



                                {/* Attachments Section */}
                                {selectedNotification.attachments?.length > 0 && (
                                    <div
                                        className="attachments-section p-4"
                                        style={{
                                            background: 'linear-gradient(to bottom, #f8fafc 0%, #ffffff 100%)',
                                            borderTop: '1px solid #e2e8f0'
                                        }}
                                    >
                                        <h6 className="fw-bold mb-3 d-flex align-items-center" style={{ color: '#1e293b' }}>
                                            <div
                                                className="icon-wrapper me-2 rounded-circle d-flex align-items-center justify-content-center"
                                                style={{
                                                    width: '36px',
                                                    height: '36px',
                                                    background: cfg.gradient
                                                }}
                                            >
                                                <i className="bi bi-paperclip text-white"></i>
                                            </div>
                                            Attachments ({selectedNotification.attachments.length})
                                        </h6>

                                        <div className="row g-3">
                                            {selectedNotification.attachments.map((att, index) => (
                                                <div key={att.id} className="col-md-6">
                                                    <div
                                                        className="attachment-card card border-0 h-100 shadow-sm"
                                                        style={{
                                                            borderRadius: '16px',
                                                            transition: 'all 0.3s ease',
                                                            background: 'white',
                                                            animation: `fadeInUp 0.5s ease ${index * 0.1}s backwards`
                                                        }}
                                                    >
                                                        <div className="card-body p-3 d-flex align-items-center gap-3">
                                                            <div
                                                                className="flex-shrink-0 rounded-3 d-flex align-items-center justify-content-center"
                                                                style={{
                                                                    width: '56px',
                                                                    height: '56px',
                                                                    background: `linear-gradient(135deg, ${cfg.color}15, ${cfg.color}05)`,
                                                                    border: `2px solid ${cfg.color}30`
                                                                }}
                                                            >
                                                                <i
                                                                    className={`${att.icon || 'bi-file-earmark'} fs-3`}
                                                                    style={{ color: cfg.color }}
                                                                ></i>
                                                            </div>

                                                            <div className="flex-grow-1 overflow-hidden">
                                                                <h6 className="mb-1 fw-bold text-truncate" style={{ fontSize: '0.9rem', color: '#1e293b' }}>
                                                                    {att.name}
                                                                </h6>
                                                                <small className="text-muted fw-medium">{att.size}</small>
                                                            </div>

                                                            <button
                                                                className="btn btn-sm rounded-circle flex-shrink-0"
                                                                style={{
                                                                    width: '40px',
                                                                    height: '40px',
                                                                    background: cfg.gradient,
                                                                    border: 'none',
                                                                    transition: 'all 0.3s ease'
                                                                }}
                                                            >
                                                                <i className="bi bi-download text-white"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                            {selectedNotification.bookmarked && (
                                <span className="badge bg-warning text-dark rounded-pill ms-2">
                                    <i className="bi bi-bookmark-fill me-1" />
                                    Bookmarked
                                </span>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default NotificationDetails;